export const DataPaygateCurrencies = [
    { value: "AFA", label: "Afghani" },
    { value: "DZD", label: "Algerian Dinar" },
    { value: "ARS", label: "Argentine Peso" },
    { value: "AMD", label: "Armenian Dram" },
    { value: "AWG", label: "Aruban Guilder" },
    { value: "AUD", label: "Australian Dollar" },
    { value: "AZM", label: "Azerbaijan Manat" },
    { value: "BSD", label: "Bahamian Dollar" },
    { value: "BHD", label: "Bahraini Dinar" },
    { value: "PAB", label: "Balboa" },
    { value: "BBD", label: "Barbados Dollar" },
    { value: "BYR", label: "Belarussian Ruble" },
    { value: "BZD", label: "Belize Dollar" },
    { value: "BMD", label: "Bermudian Dollar" },
    { value: "VEB", label: "Bolivar" },
    { value: "BOB", label: "Boliviano" },
    { value: "BAM", label: "Bosnian Convertible Mark" },
    { value: "BRL", label: "Brazilian Real" },
    { value: "BND", label: "Brunei Dollar" },
    { value: "BGN", label: "Bulgarian Lev" },
    { value: "BIF", label: "Burundi Franc" },
    { value: "CAD", label: "Canadian Dollar" },
    { value: "CVE", label: "Cape Verde Escudo" },
    { value: "KYD", label: "Cayman Is. Dollar" },
    { value: "GHC", label: "Cedi" },
    { value: "XOF", label: "CFA Franc BCEAO" },
    { value: "XAF", label: "CFA Franc BEAC" },
    { value: "XPF", label: "CFP Franc" },
    { value: "CLP", label: "Chilean Peso" },
    { value: "COP", label: "Colombian Peso" },
    { value: "KMF", label: "Comoro Franc" },
    { value: "NIO", label: "Cordoba Oro" },
    { value: "CRC", label: "Costa Rican Colon" },
    { value: "HRK", label: "Croatian Kuna" },
    { value: "CUP", label: "Cuban Peso" },
    { value: "CYP", label: "Cyprus Pound" },
    { value: "CZK", label: "Czech Koruna" },
    { value: "GMD", label: "Dalasi" },
    { value: "DKK", label: "Danish Krone" },
    { value: "MKD", label: "Denar" },
    { value: "DEM", label: "Deutsche Mark" },
    { value: "DJF", label: "Djibouti Franc" },
    { value: "STD", label: "Dobra" },
    { value: "DOP", label: "Dominican Peso" },
    { value: "VND", label: "Dong" },
    { value: "XCD", label: "E. Caribbean Dollar" },
    { value: "EGP", label: "Egyptian Pound" },
    { value: "ERN", label: "Eritean Nakfa" },
    { value: "ETB", label: "Ethiopian Birr" },
    { value: "EUR", label: "Euro" },
    { value: "XEU", label: "European Currency Unit" },
    { value: "FKP", label: "Falkland Is. Pound" },
    { value: "FJD", label: "Fiji Dollar" },
    { value: "HUF", label: "Forint" },
    { value: "New", label: "Franc Congolais (formerly" },
    { value: "GEL", label: "Georgian Lari" },
    { value: "GIP", label: "Gibraltar Pound" },
    { value: "HTG", label: "Gourde" },
    { value: "PYG", label: "Guarani" },
    { value: "GNF", label: "Guinea Franc" },
    { value: "GWP", label: "Guinea-Bissau Peso" },
    { value: "GYD", label: "Guyana Dollar" },
    { value: "HKD", label: "Hong Kong Dollar" },
    { value: "ISK", label: "Iceland Krona" },
    { value: "INR", label: "Indian Rupee" },
    { value: "IRA", label: "Iranian Airline Rate" },
    { value: "IRR", label: "Iranian Rial" },
    { value: "IQD", label: "Iraqi Dinar" },
    { value: "JMD", label: "Jamaican Dollar" },
    { value: "JOD", label: "Jordanian Dinar" },
    { value: "KES", label: "Kenyan Shilling" },
    { value: "PGK", label: "Kina" },
    { value: "LAK", label: "Kip" },
    { value: "EEK", label: "Kroon" },
    { value: "KWD", label: "Kuwaiti Dinar" },
    { value: "AOA", label: "Kwanza" },
    { value: "MMK", label: "Kyat" },
    { value: "LVL", label: "Latvian Lats" },
    { value: "LBP", label: "Lebanese Pound" },
    { value: "ALL", label: "Lek" },
    { value: "HNL", label: "Lempira" },
    { value: "SLL", label: "Leone" },
    { value: "ROL", label: "Leu" },
    { value: "LRD", label: "Liberian Dollar" },
    { value: "LYD", label: "Libyan Dinar" },
    { value: "SZL", label: "Lilangeni" },
    { value: "LTL", label: "Lithuanian Litas" },
    { value: "MGF", label: "Malagasy Franc" },
    { value: "MWK", label: "Malawi Kwacha" },
    { value: "MYR", label: "Malaysian Ringgit" },
    { value: "MTL", label: "Maltese Lira" },
    { value: "TMM", label: "Manat" },
    { value: "MUR", label: "Mauritius Rupee" },
    { value: "MZM", label: "Metical" },
    { value: "MXN", label: "Mexican Peso" },
    { value: "MDL", label: "Moldovan Leu" },
    { value: "MAD", label: "Moroccan Dirham" },
    { value: "NGN", label: "Naira" },
    { value: "NAD", label: "Namibia Dollar" },
    { value: "NPR", label: "Nepalese Rupee" },
    { value: "ANG", label: "Nether. Antillian Guilder" },
    { value: "ILS", label: "New Israeli Shekel" },
    { value: "TWD", label: "New Taiwan Dollar" },
    { value: "NZD", label: "New Zealand Dollar" },
    { value: "KPW", label: "North Korean Won" },
    { value: "NOK", label: "Norwegian Krone" },
    { value: "PEN", label: "Nuevo Sol" },
    { value: "MRO", label: "Ouguiya" },
    { value: "TOP", label: "Pa’anga" },
    { value: "PKR", label: "Pakistan Rupee" },
    { value: "MOP", label: "Pataca" },
    { value: "UYU", label: "Peso Uruguayo" },
    { value: "PHP", label: "Philippine Peso" },
    { value: "PLN", label: "Polish New Zloty" },
    { value: "GBP", label: "Pound Sterling" },
    { value: "BWP", label: "Pula" },
    { value: "QAR", label: "Qatari Rial" },
    { value: "GTQ", label: "Quetzal" },
    { value: "ZAR", label: "Rand" },
    { value: "OMR", label: "Rial Omani" },
    { value: "KHR", label: "Riel" },
    { value: "MVR", label: "Rufiyaa" },
    { value: "IDR", label: "Rupiah" },
    { value: "RUR", label: "Russian Ruble (Domestic)" },
    { value: "RUB", label: "Russian Ruble (International)" },
    { value: "RWF", label: "Rwanda Franc" },
    { value: "SAR", label: "Saudi Riyal" },
    { value: "SCR", label: "Seychelles Rupee" },
    { value: "SGD", label: "Singapore Dollar" },
    { value: "SKK", label: "Slovak Koruna" },
    { value: "SBD", label: "Solomon Is. Dollar" },
    { value: "KGS", label: "Som" },
    { value: "SOS", label: "Somali Shilling" },
    { value: "TJS", label: "Somoni" },
    { value: "LKR", label: "Sri Lanka Rupee" },
    { value: "SHP", label: "St. Helena Pound" },
    { value: "ECS", label: "Sucre" },
    { value: "SDA", label: "Sudan Airline Rate" },
    { value: "SDD", label: "Sudanese Pound" },
    { value: "SRG", label: "Surinam Guilder" },
    { value: "SEK", label: "Swedish Krona" },
    { value: "CHF", label: "Swiss Franc" },
    { value: "SYP", label: "Syrian Pound" },
    { value: "BDT", label: "Taka" },
    { value: "WST", label: "Tala" },
    { value: "TZS", label: "Tanzanian Shilling" },
    { value: "KZT", label: "Tenge" },
    { value: "THB", label: "Thailand Baht" },
    { value: "TPE", label: "Timor Escudo" },
    { value: "SIT", label: "Tolar" },
    { value: "TTD", label: "Trinidad and Tobago Dollar" },
    { value: "MNT", label: "Tugrik" },
    { value: "TND", label: "Tunisian Dinar" },
    { value: "TRL", label: "Turkish Lira" },
    { value: "AED", label: "U.A.E. Dirham" },
    { value: "USD", label: "U.S. Dollar" },
    { value: "UGX", label: "Uganda Shilling" },
    { value: "UAH", label: "Ukrainian Hryvnia" },
    { value: "UZS", label: "Uzbekistan Sum" },
    { value: "VUV", label: "Vatu" },
    { value: "KRW", label: "Won" },
    { value: "YER", label: "Yemeni Rial" },
    { value: "JPY", label: "Yen" },
    { value: "CNY", label: "Yuan Renminbi" },
    { value: "YUM", label: "Yugoslavian New Dinar" },
    { value: "CDF", label: "Zaire)" },
    { value: "ZMK", label: "Zambian Kwacha" },
    { value: "ZWD", label: "Zimbabwe Dollar" },
];
//# sourceMappingURL=paygate_currencies.js.map